import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface HVACProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const HVAC: React.FC<HVACProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [hvac, set_hvac] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Major Systems Rough-ins']?.['HVAC'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Major Systems Rough-ins': { ...b.values?.['Major Systems Rough-ins'], 'HVAC': v } } })
    );
    const label = 'HVAC';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(hvac)}
                />
            ) : (
                <MoneyBox
                    id={'hvac'}
                    allowNegative={false}
                    value={hvac}
                    onChange={(value) => set_hvac(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
